<template>
<div class="chapter">
<div class="inner_page">
<p class="toc"><b>CONTENTS</b></p>
<p class="toc1" id="ch1"><a href="#/chapter1">1 Last chance</a></p>
<p class="toc1" id="ch2"><a href="#/chapter2">2 The man who had ch’i</a></p>
<p class="toc1" id="ch3"><span href="#/chapter3" title="Link target outside of Sample">3 In motion, be like water …</span></p>
<p class="toc1" id="ch4"><span href="#/chapter4" title="Link target outside of Sample">4 The man from Rum Jungle</span></p>
<p class="toc1" id="ch5"><span href="#/chapter5" title="Link target outside of Sample">5 Night on a bare mountain</span></p>
<p class="toc1" id="ch6"><span href="#/chapter6" title="Link target outside of Sample">6 Chocolates and kisses</span></p>
<p class="toc1" id="ch7"><span href="#/chapter7" title="Link target outside of Sample">7 Council of war</span></p>
<p class="toc1" id="ch8"><span href="#/chapter8" title="Link target outside of Sample">8 The broken men</span></p>
<p class="toc1" id="ch9"><span href="#/chapter9" title="Link target outside of Sample">9 Nightfall</span></p>
<p class="toc1" id="ch10"><span href="#/chapter10" title="Link target outside of Sample">10 Dark waters</span></p>
<p class="toc1" id="ch11"><span href="#/chapter11" title="Link target outside of Sample">11 Firebird</span></p>
<p class="toc1" id="ch12"><span href="#/chapter12" title="Link target outside of Sample">12 Run to the mountain</span></p>
<p class="toc1" id="ch13"><span href="#/chapter13" title="Link target outside of Sample">13 Enter von Bayern</span></p>
<p class="toc1" id="ch14"><span href="#/chapter14" title="Link target outside of Sample">14 Crash-out</span></p>
<p class="toc1" id="ch15"><span href="#/chapter15" title="Link target outside of Sample">15 Force of arms</span></p>
<p class="toc1" id="ch16"><span href="#/chapter16" title="Link target outside of Sample">16 Last lap</span></p>
<p class="toc1" id="preview"><span href="#/preview/preview" title="Link target outside of Sample">Preview: Dark Side of the Street</span></p>
<p class="toc1" id="toc_bio"><span href="#/bio#bio01" title="Link target outside of Sample">A Biography of Jack Higgins</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?74dc62fa